/* TLR collection filters — assets/tlr-collection-filters.js

   Progressive enhancement over the GET form in sections/tlr-collection-grid.liquid.
   With this file blocked the form still filters: the panel sits inline and its SHOW
   button submits. What this adds is the mobile drawer and, on the desktop rail, an
   auto-submit so a checkbox does not need a second click on SHOW. */
(function () {
  var root = document.querySelector('.tlr-cgrid');
  if (!root) return;

  /* The site header is sticky at top:0 with its own height, so the sub-header bar has
     to know that height to park underneath it rather than behind it. */
  var head = document.querySelector('.shopify-section:has(> .tlr-header)');
  if (head) {
    var measure = function () {
      document.documentElement.style.setProperty('--tlr-header-h', head.offsetHeight + 'px');
    };
    measure();
    addEventListener('resize', measure);
    addEventListener('load', measure);
  }

  var form = root.querySelector('[data-tlr-filters]');
  var panel = root.querySelector('#tlr-filter-panel');
  if (!form || !panel) return;

  var toggle = root.querySelector('[data-tlr-filter-toggle]');
  var results = root.querySelector('[data-tlr-results]');
  var scrim = root.querySelector('.tlr-cgrid__scrim');
  var rail = matchMedia('(min-width: 1080px)');
  var lastFocus = null;

  root.classList.add('is-enhanced');

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input, select, summary'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-filter-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = focusables()[0];
    if (first) first.focus();
  }

  function close() {
    root.classList.remove('is-filter-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (root.classList.contains('is-filter-open')) close(); else open();
    });
  }

  root.querySelectorAll('[data-tlr-filter-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-filter-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Crossing up to the rail leaves the drawer classes stranded on a panel that is
     no longer fixed, and the body would stay locked. */
  rail.addEventListener('change', function () {
    if (rail.matches && root.classList.contains('is-filter-open')) close();
  });

  /* On the rail a checkbox is the whole interaction, so submit for the shopper.
     The drawer keeps its explicit SHOW button — auto-submitting there would close
     the panel out from under someone picking a second size. */
  var pending;
  form.addEventListener('change', function (e) {
    if (!rail.matches) return;
    if (e.target.name === 'sort_by') return;
    if (e.target.type === 'number') return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (results) results.classList.add('is-loading');
      /* requestSubmit fires the submit event and runs constraint validation;
         form.submit() skips both, and is only here for Safari 15. */
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }, 300);
  });

  /* Harness/QA hook: /collections/x?open renders with the drawer already out. */
  if (/(^|[?&])open(=|&|$)/.test(location.search)) open();
})();
